import _ from 'lodash';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import api from '../../../../scripts/api';
import { translate } from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class StoresConsortiumFilterFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const data = [];

        if (_.size(environment.get('CONFIG.FILTERS.GROUPS_WITH_CONSORTIUM_STORES')) > 0) {
            data.push({
                name: 'group',
                position: 1,
                visible: isAuthorized(FeaturePermission.LAYER_STORES_CONSORTIUM.filterGroup),
                fields: [{
                    title: translate('Common.Group'),
                    name: 'group',
                    dataSource: environment.get('CONFIG.FILTERS.GROUPS_WITH_CONSORTIUM_STORES'),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        if (_.size(environment.get('CONFIG.STATES')) > 1) {
            data.push({
                name: 'state',
                position: 2,
                visible: isAuthorized(FeaturePermission.LAYER_STORES_CONSORTIUM.filterUf),
                fields: [{
                    title: translate('Common.State'),
                    name: 'state',
                    dataSource: environment.get('CONFIG.STATES'),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        return data.filter(c => c.visible);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/storesConsortium.factory.js